import * as API from './api'
import * as Types from './Types'
import * as Storages from '../helpers/Storages'
import * as Constants from '../helpers/Constants'
import * as Strings from './strings'

export function trySignIn(data, language, alert) {
  return dispatch => {
    dispatch({
      type: Types.SIGN_IN_USER
    })

    API.signIn(data)
      .then(response => {
        const { token } = response.data.data

        Storages.setToken(token)

        dispatch({
          type: Types.SIGN_IN_USER_SUCCESS,
          payload: response.data.data
        })

        dispatch(tryGetSelf(token, response.data.data, language))
      })
      .catch(error => dispatch(signInFailed(error.response, language, alert)))
  }
}

function signInFailed(error, language, alert) {
  if (error && error.status === 401) {
    alert(
      Strings.default.UNAUTHORIZED[language],
      Strings.default.UNAUTHORIZED_INFO[language],
      Constants.ONE_BUTTON,
      {
        title: Strings.default.OK[language],
        onPress: () => {}
      }
    )
  } else {
    alert(
      Strings.default.INTERNAL_ERROR[language],
      Strings.default.INTERNAL_ERROR_INFO[language],
      Constants.ONE_BUTTON,
      {
        title: Strings.default.OK[language],
        onPress: () => {}
      }
    )
  }

  return {
    type: Types.SIGN_IN_USER_FAILED
  }
}

export function tryValidateSession(language) {
  return dispatch => {
    const oldToken = Storages.getToken()
    if (oldToken) {
      dispatch({
        type: Types.VALIDATE_USER
      })

      API.validateSession(oldToken)
        .then(response => {
          const { token } = response.data.data
          Storages.setToken(token)

          dispatch({
            type: Types.VALIDATE_USER_SUCCESS,
            payload: response.data.data
          })

          dispatch(tryGetSelf(token, response.data.data, language))
        })
        .catch(() => {
          dispatch(validateSessionFailed())
        })
    } else {
      dispatch(validateSessionFailed())
    }
  }
}

function validateSessionFailed() {
  return {
    type: Types.VALIDATE_USER_FAILED
  }
}

export function tryCreateCorporation(data, language, alert) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_CORPORATION
    })

    API.createCorporation(data)
      .then(response => {
        const { token } = response.data.data

        Storages.setToken(token)

        dispatch({
          type: Types.CREATE_CORPORATION_SUCCESS,
          payload: response.data.data
        })

        dispatch(tryGetSelf(token, response.data.data, language))
      })
      .catch(error => {
        dispatch({
          type: Types.CREATE_CORPORATION_FAILED
        })

        alert(
          Strings.default.INTERNAL_ERROR[language],
          Strings.default.INTERNAL_ERROR_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        )
      })
  }
}

function tryGetSelf(token, userData, language) {
  return dispatch => {
    dispatch({ type: Types.GET_SELF })
    API.getSelf(token)
      .then(response => {
        dispatch({
          type: Types.GET_SELF_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        dispatch(getSelfFailed(error, language))
      })
  }
}

function getSelfFailed(language) {
  console.log(500)

  return dispatch => {
    dispatch({
      type: Types.GET_SELF_FAILED
    })
  }
}

export function tryUpdateSelf(token, data) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_USER
    })

    API.updateUser(token, data)
      .then(response => {
        dispatch({
          type: Types.UPDATE_USER_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        const status = error.response ? error.response.status : 500

        dispatch({
          type: Types.UPDATE_USER_FAILED,
          payload: status
        })
      })
  }
}

export function signout() {
  Storages.removeToken()

  return dispatch =>
    dispatch({
      type: Types.SIGN_OUT_USER
    })
}

export function tryCreateUser(data, language, alert) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_USER
    })

    API.createUser(data)
      .then(response => {
        const { token } = response.data.data

        Storages.setToken(token)

        dispatch({
          type: Types.CREATE_USER_SUCCESS,
          payload: response.data.data
        })

        dispatch(tryGetSelf(token, response.data.data, language))
      })
      .catch(error => {
        if (error.response && error.response.status === 409) {
          alert(
            Strings.default.EMAIL_IN_USE[language],
            Strings.default.EMAIL_IN_USE_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        } else if (error.response && error.response.status === 422) {
          alert(
            Strings.default.APARTMENT_NUMBER_IN_USE[language],
            Strings.default.APARTMENT_NUMBER_IN_USE_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        } else {
          alert(
            Strings.default.INTERNAL_ERROR[language],
            Strings.default.INTERNAL_ERROR_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        }

        dispatch({
          type: Types.CREATE_USER_ERROR
        })
      })
  }
}

export function tryResetPassword(data, language, alert) {
  return dispatch => {
    dispatch({
      type: Types.RESET_PASSWORD
    })

    API.resetPassword(data)
      .then(() => {
        dispatch({
          type: Types.RESET_PASSWORD_SUCCESS
        })

        alert(
          Strings.default.RESET_PASSWORD_EMAIL_SEND[language],
          Strings.default.RESET_PASSWORD_EMAIL_SEND_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        )
      })
      .catch(error => {
        dispatch({
          type: Types.RESET_PASSWORD_FAILED
        })

        if (error.response && error.response.status === 404) {
          alert(
            Strings.default.RESET_PASSWORD_EMAIL_SEND[language],
            Strings.default.RESET_PASSWORD_EMAIL_SEND_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        } else {
          alert(
            Strings.default.INTERNAL_ERROR[language],
            Strings.default.INTERNAL_ERROR_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        }
      })
  }
}

export function validateEmailIsUnique(
  data,
  onSuccess,
  onFail,
  language,
  alert
) {
  return dispatch => {
    dispatch({
      type: Types.VALIDATE_EMAIL_IS_UNIQUE
    })

    API.emailIsUnique(data)
      .then(() => {
        dispatch({
          type: Types.VALIDATE_EMAIL_IS_UNIQUE_SUCCESS
        })

        onSuccess()
      })
      .catch(error => {
        dispatch({
          type: Types.VALIDATE_EMAIL_IS_UNIQUE_FAILED
        })

        if (error.response && error.response.status === 409) {
          onFail()
        } else {
          alert(
            Strings.default.INTERNAL_ERROR[language],
            Strings.default.INTERNAL_ERROR_INFO[language],
            Constants.ONE_BUTTON,
            {
              title: Strings.default.OK[language],
              onPress: () => {}
            }
          )
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/User.js